export const resolveInternalTemplateHref = (href, currentHref) => {
  const value = String(href || '').trim();
  if (!value || value === '#' || /^(mailto:|tel:|sms:|javascript:|data:|blob:)/i.test(value)) return '';

  try {
    const currentUrl = new URL(currentHref || window.location.href);
    const targetUrl = new URL(value, currentUrl);
    if (!/^https?:$/i.test(targetUrl.protocol) || targetUrl.origin !== currentUrl.origin) return '';
    return `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}` || '/';
  } catch {
    return '';
  }
};

export default resolveInternalTemplateHref;
